import { useMutation, useQuery } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

import type { IProductCategory } from "../../interfaces";

export default function useProductCategory() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useList() {
        return useQuery({
            queryKey: ["product-categories"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/product-categories/list");
                return parseSuccessResponseData(response);
            },
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: async (data: {
                Name: string;
                Description?: string;
                DefaultUnitType?: string;
                MeasurementTypes?: any;
                IsActive?: boolean;
                Tags?: Record<string, string>;
            }) => {
                const response = await axiosPrivate.post<IProductCategory>("/v1/product-categories/create", data);
                return parseSuccessResponseData(response);
            },
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: async (data: {
                Id: string;
                Name?: string;
                Description?: string;
                DefaultUnitType?: string;
                MeasurementTypes?: any;
                IsActive?: boolean;
                Tags?: Record<string, string>;
            }) => {
                const response = await axiosPrivate.post<IProductCategory>("/v1/product-categories/update", data);
                return parseSuccessResponseData(response);
            },
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: async (id: string) => {
                const response = await axiosPrivate.delete(`/v1/product-categories/delete/${id}`);
                return parseSuccessResponseData(response);
            },
        });
    }

    return {
        useList,
        useCreate,
        useUpdate,
        useDelete,
    };
}
